import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import PublicLayout from "@/components/public/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import { Link } from "react-router-dom";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import LegislativeWork from "@/pages/public/LegislativeWork";
import BillDetail from "@/pages/public/BillDetail";
import ActionAlerts from "@/pages/public/ActionAlerts";
import ActionAlertDetail from "@/pages/public/ActionAlertDetail";
import PriorityDetail from "@/pages/public/PriorityDetail";
import { Statements, StatementDetail } from "@/pages/public/Statements";
import { EventsList, EventDetail } from "@/pages/public/Events";
import VoterGuide from "@/pages/public/VoterGuide";
import { JoinNetwork, Contact, FindMyLegislator, Jobs, Resources, BishopLetters } from "@/pages/public/Misc";
import BishopSignRequest from "@/pages/public/BishopSignRequest";
import PriestPortal from "@/pages/public/PriestPortal";
import { HomilyArchiveList, HomilyArchiveDetail } from "@/pages/public/HomilyArchive";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Contacts from "@/pages/admin/Contacts";
import Bills from "@/pages/admin/Bills";
import StatementsAdmin from "@/pages/admin/StatementsAdmin";
import Campaigns from "@/pages/admin/Campaigns";
import EventsAdmin from "@/pages/admin/EventsAdmin";
import Emails from "@/pages/admin/Emails";
import AnnouncementAdmin from "@/pages/admin/Announcement";
import Tasks from "@/pages/admin/Tasks";
import Inbox from "@/pages/admin/Inbox";
import Conversations from "@/pages/admin/Conversations";
import PublicThemes from "@/pages/admin/PublicThemes";
import Legislators from "@/pages/admin/Legislators";
import LegislatorBrief from "@/pages/admin/LegislatorBrief";
import EmailTemplates from "@/pages/admin/EmailTemplates";
import ContactDetail from "@/pages/admin/ContactDetail";
import Experiments from "@/pages/admin/Experiments";
import Automations from "@/pages/admin/Automations";
import Team from "@/pages/admin/Team";
import NotFound from "@/pages/public/NotFound";

function App() {
  return (
    <AuthProvider>
      <LangProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout/>}>
            <Route index element={<Home/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/legislative-work" element={<LegislativeWork/>}/>
            <Route path="/legislative-work/:id" element={<BillDetail/>}/>
            <Route path="/priorities/:slug" element={<PriorityDetail/>}/>
            <Route path="/take-action" element={<Navigate to="/take-action/action-alerts" replace/>}/>
            <Route path="/take-action/action-alerts" element={<ActionAlerts/>}/>
            <Route path="/take-action/action-alerts/:slug" element={<ActionAlertDetail/>}/>
            <Route path="/take-action/join" element={<JoinNetwork/>}/>
            <Route path="/take-action/events" element={<EventsList/>}/>
            <Route path="/take-action/events/:slug" element={<EventDetail/>}/>
            <Route path="/take-action/find-my-legislator" element={<FindMyLegislator/>}/>
            <Route path="/resources" element={<Resources/>}/>
            <Route path="/resources/statements" element={<Statements/>}/>
            <Route path="/resources/statements/:slug" element={<StatementDetail/>}/>
            <Route path="/resources/bishop-letters" element={<BishopLetters/>}/>
            <Route path="/resources/voter-guide" element={<VoterGuide/>}/>
            <Route path="/resources/homily-digest" element={<HomilyArchiveList/>}/>
            <Route path="/resources/homily-digest/:weekKey" element={<HomilyArchiveDetail/>}/>
            <Route path="/2024-voter-guide" element={<VoterGuide/>}/>
            <Route path="/ccc-statements" element={<Navigate to="/resources/statements" replace/>}/>
            <Route path="/bishop-letters" element={<Navigate to="/resources/bishop-letters" replace/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="/jobs" element={<Jobs/>}/>
            <Route path="*" element={<NotFound/>}/>
          </Route>

          {/* Admin auth */}
          <Route path="/admin/login" element={<Login/>}/>

          {/* Bishop signature request — public URL with HMAC token; no layout */}
          <Route path="/sign-request/statement/:sid" element={<BishopSignRequest/>}/>

          {/* Priest self-serve portal — public URL with HMAC token; no layout */}
          <Route path="/priest-portal/:priestId" element={<PriestPortal/>}/>

          {/* Admin protected */}
          <Route path="/admin" element={<ProtectedRoute><AdminLayout/></ProtectedRoute>}>
            <Route index element={<Dashboard/>}/>
            <Route path="inbox" element={<Inbox/>}/>
            <Route path="tasks" element={<Tasks/>}/>
            <Route path="conversations" element={<Conversations/>}/>
            <Route path="public-themes" element={<PublicThemes/>}/>
            <Route path="legislators" element={<Legislators/>}/>
            <Route path="legislators/:id/brief" element={<LegislatorBrief/>}/>
            <Route path="email-templates" element={<EmailTemplates/>}/>
            <Route path="contacts" element={<Contacts/>}/>
            <Route path="contacts/:id" element={<ContactDetail/>}/>
            <Route path="campaigns" element={<Campaigns/>}/>
            <Route path="bills" element={<Bills/>}/>
            <Route path="statements" element={<StatementsAdmin/>}/>
            <Route path="events" element={<EventsAdmin/>}/>
            <Route path="emails" element={<Emails/>}/>
            <Route path="announcement" element={<AnnouncementAdmin/>}/>
            <Route path="experiments" element={<Experiments/>}/>
            <Route path="automations" element={<Automations/>}/>
            <Route path="team" element={<Team/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
      </LangProvider>
    </AuthProvider>
  );
}

export default App;
